<template>
  <div v-wechat-title="title">
    <Header class="m-pc" :extras="extras" platform="pc"></Header>
    <template v-if="!errorMessage && !showInWechat">
      <div class="question-main">
        <div
          class="question-title"
          :style="{
            display:
              extraItem.extras('titlefont.display') == 1 ? 'block' : 'none',
            color: extraItem.extras('titlefont.color'),
            fontSize: pxOrVw(extraItem.extras('titlefont.size')),
            fontWeight:
              extraItem.extras('titlefont.weight') == 'default'
                ? '500'
                : extraItem.extras('titlefont.weight'),
          }"
        >
          {{ title }}
        </div>
        <pc-fields :form="questionnaireList" :extras="extras" />
      </div>
      <div class="question-footer" v-if="isShowBtn">
        <div
          class="question-footer-btn"
          @click="submit()"
          :style="{ cursor: isPreview ? 'not-allowed' : 'pointer' }"
        >
          提交
        </div>
      </div>
    </template>
    <div class="m-currency-content" v-if="errorMessage && !showInWechat">
      <form-status
        :status="
          questionaryStatus == 0
            ? 'nostart'
            : questionaryStatus == 2
            ? 'over'
            : 'error'
        "
        :test="errorMessage"
        platform="pc"
      ></form-status>
    </div>
    <WeChat v-if="showInWechat" :qrcodeUrl="qrcodeUrl" />
    <CountDown
      ref="count-down"
      :extras="extras"
      platform="pc"
      :totalTimeM="
        questionnaireInfo.isTimeLimit == '2' ? questionnaireInfo.limitTime : 0
      "
      :costTime="costTime"
      @calibration="questionnaireTimeGet"
      @autoSubmit="submit"
    ></CountDown>
  </div>
</template>

<script>
import questionaryMixin from "../../../mixins/questionary";
import templateMixin from "../../../mixins/exam-random-config";
import Api from "../../../service/api";
import WX from "../../../utils/wx";
import Utils from "../../../utils/index";
import { forkJoin } from "rxjs";
import { cr } from "fire-wind-water";
import { interact, URLS } from "fire-wind-water";
import PcFields from "@/components/PcFields.vue";
export default {
  name: "examRandomPcQuestionnaire",
  mixins: [templateMixin, questionaryMixin],
  components: {
    PcFields,
  },
  data() {
    return {};
  },
  methods: {
    getQuestionnaire() {
      forkJoin(
        this.handleBindData(),
        this.questionnaireGet(),
        this.getGenerateExam()
      ).subscribe((res) => {
        const data = res[1];
        let examRandom = res[2].content ? res[2].content.items : [];
        cr.each(examRandom, (m) => {
          if (m.fieldLevel == 4) {
            cr.each(m.optionsContent, (u) => {
              u.title = u.name;
              u.optionId = u.id;
            });
            m.options = m.optionsContent;
            m.itemId = m.id;
            m.question = m.title;
            m.fieldName = "r" + m.id;
          }
        });
        if (data.content.items) {
          data.content.items = [...data.content.items, ...examRandom];
        }
        this.questionnaireInfo = data.content;
        // this.questionnaireInfo.limitTime = 0.1;//pegmca
        this.lookUpInfo =
          res[0] && this.questionnaireInfo.attendWay != 1 ? res[0].content : [];
        const platform = interact.isMobile == 1 ? "wap" : "pc";
        const anotherPlatform = interact.isMobile == 1 ? "pc" : "wap";
        if (
          window == parent &&
          location.hash.indexOf("/" + platform + "/") == -1
        ) {
          if (this.isPreview) {
            window.location.href = window.location.href
              .replace("/" + anotherPlatform + "/", "/" + platform + "/")
              .replace(
                this.questionnaireInfo.template[anotherPlatform]["configId"],
                this.questionnaireInfo.template[platform]["configId"]
              );
          } else {
            window.location.href =
              this.questionnaireInfo.shortUrl[platform].normal;
          }
          return;
        }
        Utils.changeHash(this.questionnaireInfo); //判断问卷类型跳转对应路由
        if (interact.isWeChat) {
          WX.initWeChatShare(this.questionnaireInfo);
        }
        this.title = this.questionnaireInfo.title;
        this.identity = this.questionnaireInfo.attendWay;
        window.$sk.template.update({
          type: "link",
          data: {
            identity: this.questionnaireInfo.attendWay,
            weChatId: this.questionnaireInfo.attachWXAccount,
            skObjectType: "questionary",
            skObjectId: this.questionnaireId,
            meetingInstanceId:
              this.questionnaireInfo.attendWay == 4
                ? this.questionnaireInfo.meetingInstanceId
                : this.instanceId,
            meetingType: this.questionnaireInfo.meetingType,
            skIsNotLink: this.isPreview ? 1 : 0,
            memberFormId: this.questionnaireInfo.regFormId,
          },
        });
      });
    },
    submit(isAutoAction = 0) {
      if (this.isSetting) {
        window.$sk.alert("当前页面不支持提交");
        return;
      }
      if (this.isPreview) {
        //试卷类型预览不提交
        return;
      }
      if (this.hasJoin) {
        return;
      }
      if (this.identity == null || this.contactInfo == null) {
        window.$sk.alert("请登录");
        return false;
      }
      if (this.questionnaireInfo.attentionWeChat == "1") {
        window.$sk.alert("请在微信中参与");
        return false;
      }

      console.log("userINfo--", this.contactInfo);
      this.questionnaireList = this.questionnaireList.filter((m) => {
        m.checkFlag = !m.checkFlag; //触发校验
        return true;
      });
      // cr.each(this.questionnaireList, (m) => {
      //   m.checkFlag = !m.checkFlag; //触发校验
      // });
      this.$nextTick(() => {
        console.log("res--questionnaireList--", this.questionnaireList);
        let isValid = true; //校验结果
        let hasAnswers = 0;
        cr.each(this.questionnaireList, (m) => {
          if (m.value) {
            if (m.value.value && m.value.value.length) {
              hasAnswers++;
            }
            if (m.value.VerifyFail) {
              isValid = false;
            }
          }
        });
        if (isValid || isAutoAction) {
          //通过校验
          if (hasAnswers === 0 && !isAutoAction) {
            window.$sk.alert("请至少填写一个字段信息");
            return false;
          }
          if (this.isSubmitting) {
            return;
          }
          this.isSubmitting = true;
          let submitFields = [];
          cr.each(this.questionnaireList, (m) => {
            if (m.fieldLevel == 4) {
              if (
                m.displayType == 3 ||
                m.displayType == 4 ||
                m.displayType == 5 ||
                m.displayType == 6
              ) {
                //单选/多选
                let options = [];
                if (m.result && Array.isArray(m.result.model)) {
                  //多选
                  cr.each(m.result.model, (u) => {
                    options.push(u.optionId);
                  });
                } else {
                  //单选
                  options = [m.result.model.optionId];
                }
                submitFields.push({
                  id: m.itemId,
                  selected: options,
                });
              }
            } else {
              if (m.fieldType != "POLICY") {
                if (m.fieldName === "mobile" && m.value.checkCode) {
                  submitFields.push({
                    fieldName: m.value.fieldName,
                    value: m.value.value,
                    checkCode: m.value.checkCode,
                  });
                } else {
                  submitFields.push({
                    fieldName: m.value.fieldName,
                    value: m.value.value,
                  });
                }
              } else {
                submitFields.push({
                  fieldName: m.value.fieldName,
                  value: m.value.value,
                });
              }
            }
          });
          console.log("submitFields", submitFields);
          this.actionFun(submitFields, isAutoAction);
        } else {
          this.validationErrorHandler();
        }
      });
    },
    actionFun(answers, isAutoAction = 0) {
      let params = {
        questionaryId: this.questionnaireId,
        globalUserId: this.globalUserId,
        referenceUrl: document.referrer,
        options: answers,
        url: window.location.href,
        preview: this.isPreview ? 1 : 0,
        sess: this.sess,
        session: this.sess,
        memberId: null,
        linkId: URLS.getURL("linkId") || URLS.getHash("linkId"),
        unique: this.contactInfo.unique ? this.contactInfo.unique : "",
        enteredId: this.enteredId,
        instanceId: this.instanceId || 0,
        type: this.questionnaireInfo.type,
        _withAsync: this.questionnaireInfo.type == 3 ? 0 : 1,
        isAutoAction: isAutoAction,
        token: this.limitTimeToken,
        costTime: this.$refs["count-down"].costTimeFront,
      };
      if (interact.isMobile) {
        let weixinId =
          this.questionnaireInfo.attachWXAccount &&
          this.questionnaireInfo.attachWXAccount != 0
            ? this.questionnaireInfo.attachWXAccount
            : URLS.getHash("weChatId");
        Object.assign(params, {
          openId: this.contactInfo.openId,
          weChatId: weixinId,
        });
      }
      this.contactInfo.token = this.limitTimeToken; //this.contactInfo存在token字段
      Object.assign(params, this.contactInfo);
      Api.actionGenerateExam(params).subscribe((data) => {
        this.isSubmitting = false;
        let _this = this;
        if (data.result == 0) {
          if (data.content.repeatAction == 1) {
            window.$sk.confirm("您已提交过，是否直接进入下一步？", {
              okValue: "下一步",
              ok: function () {
                _this.judgeCompleteActionType(
                  _this.questionnaireInfo.completeActionType,
                  _this.questionnaireInfo.completeAction,
                  data.content
                ); // 判断问卷结束后行为
              },
            });
          } else {
            _this.judgeCompleteActionType(
              _this.questionnaireInfo.completeActionType,
              _this.questionnaireInfo.completeAction,
              data.content
            ); // 判断问卷结束后行为
          }
        } else if (data.result == "100040") {
          window.$sk.confirm(data.desc, {
            okValue: "下一步",
            ok: function () {
              _this.judgeCompleteActionType(
                _this.questionnaireInfo.completeActionType,
                _this.questionnaireInfo.completeAction,
                data.content
              ); // 判断问卷结束后行为
            },
          });
        } else {
          window.$sk.alert(data.desc);
        }
      });
    },
    getGenerateExam() {
      return Api.getGenerateExam({
        globalUserId: this.globalUserId,
        isPreview: this.isPreview ? 1 : 0,
        isSave: 1,
        openId: this.contactInfo.openId,
        questionaryId: this.questionnaireId,
        sess: "",
        tenantId: this.tenantId,
      });
    },
  },
};
</script>

<style scoped></style>
